import React from 'react';
import { products } from '../data/products';
import ProductCard from './ProductCard';

function ProductCatalog({ onProductClick, lang }) {
  return (
    <section id="products" className="product-catalog">
      <div className="container">
        <h2 className="section-title">
          {lang === 'it' ? 'Termoventilatori per ambienti' : 'Обогреватели для помещений'}
        </h2>
        <p className="section-subtitle">
          {lang === 'it'
            ? 'Termoventilatori a pannelli in vetro premium con controllo WiFi'
            : 'Инфаракрасные обогреватели для влажного климата'
          }
        </p>

        <div className="products-grid">
          {products.heaters.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onClick={onProductClick}
              lang={lang}
            />
          ))}
        </div>

        <div className="tech-info">
          <h3>
            {lang === 'it' ? 'Tecnologia di riscaldamento' : 'Технология нагрева'}
          </h3>
          <p>
            {lang === 'it'
              ? 'I nostri termoventilatori utilizzano una combinazione di radiazione infrarossa e correnti d\'aria convettive:'
              : 'Наши обогреватели используют комбинацию инфракрасного излучения и конвективных потоков воздуха:'
            }
          </p>
          <ul>
            <li>
              <strong>
                {lang === 'it' ? 'Riscaldamento rapido' : 'Быстрый нагрев'}
              </strong>{' '}
              {lang === 'it'
                ? 'grazie all\'ampia superficie di contatto con l\'aria'
                : 'благодаря большой площади контакта с воздухом'
              }
            </li>
            <li>
              <strong>
                {lang === 'it' ? 'Miscelazione uniforme' : 'Равномерное перемешивание'}
              </strong>{' '}
              {lang === 'it'
                ? 'dell\'aria per una temperatura bilanciata nell\'ambiente'
                : 'воздуха для сбалансированной температуры в помещении'
              }
            </li>
            <li>
              <strong>
                {lang === 'it' ? 'Efficienza energetica' : 'Энергоэффективность'}
              </strong>{' - '}
              {lang === 'it'
                ? 'consumo 250-300W/h invece dei 500-670W dichiarati'
                : 'среднее потребление 250-300Вт*ч при максимальной мощности 500-670Вт'
              }
            </li>
            <li>
              <strong>
                {lang === 'it' ? 'Inerzia' : 'Инерционность'}
              </strong>{' - '}
              {lang === 'it'
                ? 'dopo il riscaldamento e lo spegnimento mantengono il calore a lungo'
                : 'после прогрева и отключения сохраняют тепло длительное время'
              }
            </li>
            <li>
              <strong>
                {lang === 'it' ? 'Sicurezza' : 'Безопасность'}
              </strong>{' - '}
              {lang === 'it'
                ? 'Nessun rischio di surriscaldamento o incendio, adatto per bagni, nessun contatto degli elementi riscaldanti con l\'aria, non brucia ossigeno o polvere'
                : 'нет опасности перегрева и возгорания, подходит для ванных комнат, нет контакта нагревательных элементов с воздухом, не сжигает кислород и пыль'
              }
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default ProductCatalog;
